import {result} from 'lodash';
import DatasetAttributeModel from './dataset_attribute';
import {ATTRIBUTES} from "../../../../utils/query_utils";

export default class MeasureModel extends DatasetAttributeModel {
    type = ATTRIBUTES.MEASURE;
    aggregation = null;

    constructor({aggregation = null, ...otherProps} = {}) {
        super(otherProps);
        this.setAggregation(aggregation);
    }

    setAggregation(agg) {
        this.aggregation = agg;
    }

    isComplete() {
        return super.isComplete() && !!this.aggregation;
    }

    get label() {
        return `${result(this.aggregation, 'label', '')} ${result(this.column, 'fullName', '')}`.trim();
    }

    get sql() {
        return this.aggregation.getSql(this.column);
    }
}
